import { useQuery } from '@apollo/client';

import { CLINIC_IDENTITY_QUERY } from '@/modules/settings/settings.gql';

/** Clinic branding used by every print document (receta, expediente). */
export interface ClinicBranding {
  clinic_name: string;
  logo_url: string | null;
  brand_color_hex: string;
  address_line: string | null;
  phone_primary: string | null;
  phone_secondary: string | null;
  email: string | null;
  website: string | null;
  facebook_handle: string | null;
  has_24h_service: boolean;
}

interface ClinicIdentityResponse {
  clinicIdentity: ClinicBranding & { is_configured: boolean };
}

// Mirrors the Totem branding already hardcoded in abono-ticket-print.ts (cash tickets) so
// print documents never render blank/NovaPet branding before the query resolves or when
// clinic.identity has never been configured — the backend returns these same literals.
const FALLBACK_BRANDING: ClinicBranding = {
  clinic_name: 'Hospital Veterinario de Especialidades Totem',
  logo_url: '/totem_logo_ticket.png',
  brand_color_hex: '#194D9D',
  address_line: null,
  phone_primary: '618 112 3896',
  phone_secondary: null,
  email: null,
  website: null,
  facebook_handle: '@hospital.totem',
  has_24h_service: false,
};

export function useClinicIdentity(): ClinicBranding {
  const { data } = useQuery<ClinicIdentityResponse>(CLINIC_IDENTITY_QUERY, {
    fetchPolicy: 'cache-first',
  });
  const identity = data?.clinicIdentity;
  if (!identity) return FALLBACK_BRANDING;
  const { is_configured: _is_configured, ...branding } = identity;
  return branding;
}
